import { IProfilingCode } from 'legacy/lut/classes/models/profiling/codes'

import { I515Form } from 'clickNgo/models/crud/forms/i515Form'

export const mapProfilingCodeFrom515Form = (data: I515Form): IProfilingCode => ({
  entryId: data.EntryId || '',
  code: data.Code || '',
  codeType: data.Type || '',
  roles: data.Roles ? data.Roles.split(';') : [],
  codeName: data.CodeName || '',
  countries: data.Countries || '',
  markets: data.GeoMarket ? data.GeoMarket.split(';') : [],
  users: data.Users ? data.Users.split(';') : [],
})
